import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "mdi_clear_7ea22c14005cc91b1853f9fb8d21c49f",
  "use": "mdi_clear_7ea22c14005cc91b1853f9fb8d21c49f-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"mdi_clear_7ea22c14005cc91b1853f9fb8d21c49f\">\n    <path fill=\"#BDBDBD\" stroke=\"#BDBDBD\" d=\"M6.646 8.36l-.353-.353.353-.353 1.008-1.008.353-.353.354.353L12 10.286l3.64-3.64.353-.353.353.353 1.008 1.008.353.353-.353.354L13.714 12l3.64 3.64.353.353-.353.353-1.008 1.008-.353.353-.354-.353L12 13.714l-3.64 3.64-.353.353-.353-.353-1.008-1.008-.353-.353.353-.354L10.286 12l-3.64-3.64z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id